import {Injectable} from '@angular/core';

import {HttpClient, HttpHeaders, HttpResponse, HttpErrorResponse} from '@angular/common/http';
import {Response} from '@angular/http';
import {Observable} from 'rxjs/Observable';
import {BaseService} from './BaseService';
import {Ng4LoadingSpinnerService} from 'ng4-loading-spinner';
import 'rxjs/add/operator/map';


@Injectable()
export class ImportPurchaseOrderService {
    constructor(private http: HttpClient, private baseurl: BaseService, private spinnerService: Ng4LoadingSpinnerService) {}

    saveImpPO(data) {
        let url: string = "/createImportPurchaseOrder";
        let body = JSON.stringify(data);
        console.log("**##", body)
        const headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');
        this.spinnerService.show()
        return this.http.post(this.baseurl.url + url, body, {headers}).map((res) => {
            res;
            this.spinnerService.hide()
            return res
        }).catch(
            (error: Response) => {
                this.spinnerService.hide()
                return Observable.throw(error);
            });
    }
    updateImpPO(data) {
        let url: string = "/updateImportPurchaseOrder";
        let body = JSON.stringify(data);
        console.log("**##", body)
        const headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');
        this.spinnerService.show()
        return this.http.put(this.baseurl.url + url + '/' + data.id, body, {headers}).map((res) => {
            res;
            this.spinnerService.hide()
            return res
        }).catch(
            (error: Response) => {
                this.spinnerService.hide()
                return Observable.throw(error);
            });
    }
    findPObyid(id: number) {
        let url: string = "/findImportPurchaseOrderId";
        let body = JSON.stringify({
            id: id
        });
        console.log("$$", body)
        const headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');
        this.spinnerService.show()
        return this.http.post(this.baseurl.url + url, body, {headers}).map((res) => {
            res;
            return res
        }).catch(
            (error: Response) => {
                this.spinnerService.hide()
                return Observable.throw(error);
            });
    }
    searchImpPO(data) {
        let url: string = "/searchImportPurchaseOrder";
        let body = JSON.stringify(data);
        console.log(body)
        const headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');
        this.spinnerService.show()
        return this.http.post(this.baseurl.url + url, body, {headers}).map((res) => {
            res;
            this.spinnerService.hide()
            return res
        }).catch(
            (error: Response) => {
                this.spinnerService.hide()
                return Observable.throw(error);
            });
    }
    generateExcel(data) {
        let url: string = "/generateImportPurchaseOrderReport";
        let body = JSON.stringify({
            printType: 'EXCEL',
            pono: data.pono, poDate: data.poDate, qty: data.qty, expectedDeliveryDate: data.expectedDeliveryDate,
            actualDeliveryDate: data.actualDeliveryDate, status: data.status, amount: data.amount, rate: data.rate, fromDate: data.fromDate,
            toDate: data.toDate
        });
        console.log(body)
        const headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8').set('responseType', 'arrayBuffer');
        this.spinnerService.show()
        return this.http.post(this.baseurl.url + url, body, {headers, responseType: 'text'}).map((res) => {
            res;
            this.spinnerService.hide()
            return res
        }).catch(
            (error: Response) => {
                this.spinnerService.hide()
                return Observable.throw(error);
            });
    }

}


// WEBPACK FOOTER //
// D:/ESealStore_AJS/src/app/service/ImportPurchaseOrderService.ts